/**
 * Values for `user.defaultInsightsLens` — must match msb-api user schema allow list.
 * Used by Coach Preferences and (later) Program Insights default lens.
 */
export const DEFAULT_INSIGHTS_LENS = "hypertrophy_general" as const;

export const INSIGHTS_LENS_SLUGS = [
  "hypertrophy_general",
  "powerlifting",
  "olympic_weightlifting",
  "strongman",
  "streetlifting",
] as const;

/**
 * Program Insights default lens resolution chain:
 * athlete client config → coach preference → org owner → global default.
 * Uses nullish coalescing so only `undefined` / `null` falls through.
 */
export function getEffectiveDefaultInsightsLens(
  coachLike?: { defaultInsightsLens?: string | null },
  orgOwnerLike?: { defaultInsightsLens?: string | null },
  clientConfigLike?: { defaultInsightsLens?: string | null }
): string {
  return (
    clientConfigLike?.defaultInsightsLens ??
    coachLike?.defaultInsightsLens ??
    orgOwnerLike?.defaultInsightsLens ??
    DEFAULT_INSIGHTS_LENS
  );
}

export type OneRmSummaryLift =
  | "squat"
  | "bench"
  | "deadlift"
  | "snatch"
  | "clean"
  | "jerk";

/**
 * Lifts shown in the athlete 1RMs summary of the Program Editor, per lens.
 * Lenses without an entry (hypertrophy_general, strongman) hide the summary.
 */
const ONE_RM_SUMMARY_LIFTS_BY_LENS: Readonly<
  Record<string, readonly OneRmSummaryLift[]>
> = {
  powerlifting: ["squat", "bench", "deadlift"],
  streetlifting: ["squat", "bench", "deadlift"],
  olympic_weightlifting: ["snatch", "clean", "jerk", "squat"],
};
/**
 * Get the lifts shown in the athlete 1RMs summary of the Program Editor, per lens.
 * @param lens - The lens to get the lifts for.
 * @returns The lifts shown in the athlete 1RMs summary of the Program Editor, per lens.
 */
export function getOneRmSummaryLifts(
  lens?: string | null
): readonly OneRmSummaryLift[] {
  return (lens && ONE_RM_SUMMARY_LIFTS_BY_LENS[lens]) || [];
}
